import { CloseFullscreenRounded, HubRounded, OpenInFullRounded, TableRowsOutlined } from "@mui/icons-material";
import {
  Box,
  Card,
  CardHeader,
  Divider,
  IconButton,
  Stack,
  SxProps,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useBreakpoints, useSettings } from "../../../../hooks";
import { TeamNetworkGraph } from "./TeamNetworkGraph";
import { TeamNetworkList } from "./TeamNetworkList";
import { TooltipToggleButton } from "../../../../components";
import { TeamOverviewSection } from "src/constants";

interface IProps {
  teamSlug: string | undefined;
  sx?: SxProps;
}

const TeamNetwork = (props: IProps) => {
  const { teamSettings, updateTeamSettings } = useSettings();
  const { isMdUp } = useBreakpoints();

  return (
    <Card sx={{ ...props.sx }}>
      <CardHeader
        title={
          <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Typography variant="h6">Network</Typography>
              {isMdUp && (
                <IconButton
                  variant="tertiary"
                  onClick={() => {
                    updateTeamSettings({
                      ...teamSettings,
                      expandedSection:
                        teamSettings.expandedSection === TeamOverviewSection.Network
                          ? undefined
                          : TeamOverviewSection.Network,
                    });
                    window.scrollTo({ top: 0 });
                  }}
                >
                  {teamSettings.expandedSection === TeamOverviewSection.Network ? (
                    <CloseFullscreenRounded />
                  ) : (
                    <OpenInFullRounded />
                  )}
                </IconButton>
              )}
            </Stack>
            <ToggleButtonGroup
              value={teamSettings.networkListView}
              color="primary"
              size="small"
              exclusive
              onChange={(_e, value: boolean) => updateTeamSettings({ ...teamSettings, networkListView: value })}
            >
              <TooltipToggleButton title="Graph View" value={false}>
                <HubRounded fontSize="small" />
              </TooltipToggleButton>

              <TooltipToggleButton title="List View" value={true}>
                <TableRowsOutlined fontSize="small" />
              </TooltipToggleButton>
            </ToggleButtonGroup>
          </Stack>
        }
      />
      <Divider />
      {!teamSettings.networkListView && (
        <Box
          sx={{
            height: { xs: "100vw", md: 670 },
            width: "100%",
          }}
        >
          <TeamNetworkGraph teamSlug={props.teamSlug} />
        </Box>
      )}
      {teamSettings.networkListView && <TeamNetworkList teamSlug={props.teamSlug} />}
    </Card>
  );
};

export { TeamNetwork };
